import React, { Component } from 'react'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
import FacebookIcon from '../icons/FacebookIcon'
import GoogleIcon from '../icons/GoogleIcon'

class StyledButton extends Component {
  render() {
    return (
      <FlatButton
        backgroundColor='#fff'
        hoverColor='#eee'
        icon={this.props.icon}
        label={this.props.label}
        onClick={this.props.onClick}
        style={{
          flex: '1',
          margin: this.props.margin || '',
          lineHeight: 'inherit'
        }}
        type={this.props.type}
      />
    )
  }
}

class StyledInput extends Component {
  render() {
    return (
      <TextField
        id={this.props.id}
        floatingLabelText={this.props.label}
        floatingLabelStyle={{ color: '#fff' }}
        floatingLabelFocusStyle={{ color: '#fff' }}
        inputStyle={{ color: '#fff' }}
        underlineStyle={{ borderColor: '#eee' }}
        underlineFocusStyle={{ borderColor: '#fff' }}
        onChange={this.props.onChange}
        style={{ display: 'block' }}
        type={this.props.type}
        value={this.props.value}
      />
    )
  }
}

export default class LoginForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: '',
      pass: ''
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.passwordSignup = this.passwordSignup.bind(this)
    this.updateField = this.updateField.bind(this)
  }

  handleSubmit(event) {
    event.preventDefault()
    this.props.login(this.state.user, this.state.pass)
  }

  passwordSignup(event) {
    event.preventDefault()
    this.props.signUp(this.state.user, this.state.pass)
  }

  updateField(event, value) {
    this.setState({ [event.target.id]: value })
  }

  render() {
    let googleLogin
    if (this.props.googleLogin) {
      googleLogin = (
        <div style={{
          display: 'flex',
          marginTop: '20px'
        }}>
          <StyledButton
            label='Sign In With Google'
            onClick={this.props.googleLogin}
            icon={<GoogleIcon />}
          />
        </div>
      )
    }

    let facebookLogin
    if (this.props.facebookLogin) {
      facebookLogin = (
        <div style={{
          display: 'flex',
          marginTop: '20px'
        }}>
          <StyledButton
            label='Sign In With Facebook'
            onClick={this.props.facebookLogin}
            icon={<FacebookIcon />}
          />
        </div>
      )
    }

    return (
      <form id='loginForm' onSubmit={this.handleSubmit}>
        <StyledInput
          id='user'
          label='Email Address'
          onChange={this.updateField}
          type='email'
          value={this.state.user}
        />
        <StyledInput
          id='pass'
          label='Password'
          onChange={this.updateField}
          type='password'
          value={this.state.pass}
        />
        <div style={{
          display: 'flex',
          marginTop: '25px'
        }}>
          <StyledButton
            label='Sign Up'
            margin='0 5px 0 0'
            onClick={this.passwordSignup}
          />
          <StyledButton
            label='Login'
            margin='0 0 0 5px'
            onClick={this.handleSubmit}
            type='submit'
          />
        </div>
        {googleLogin}
        {facebookLogin}
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginForm.js